/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import Request from './request';

export const apiGetProductList = (data) => {
  return Request.call({
    url: `/product/list`,
    method: 'POST',
    data,
  });
};

export const apiCreateProductTesting = (data) => {
  return Request.call({
    url: `/productTestings`,
    method: 'POST',
    data,
  });
};

export const apiProductTestingDetail = (id) => {
  return Request.call({
    url: `/productTestings/${id}`,
    method: 'GET',
  });
};

export const apiUpdateProductTesting = (id, data) => {
  return Request.call({
    url: `/productTestings/${id}`,
    method: 'PATCH',
    data,
  });
};

export const apiAdminChangeStatus = (id, data) => {
  return Request.call({
    url: `/micro/product-testings/${id}/status`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiUpdateECD = (id, data) => {
  return Request.call({
    url: `/micro/product-testings/${id}/ecd`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
